import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  margin-right: auto;
  margin-left: auto;
  padding-left: 30px;
  padding-right: 30px;
  width: 100%;
  max-width: ${({ narrow }) => (narrow ? '1080' : '1280')}px;
`;

export const Container = ({ narrow, children, ...props }) => (
  <StyledContainer narrow={narrow} {...props}>
    {children}
  </StyledContainer>
);
